import { Grid, GridItem, Icon, Text } from "@innovationnorway/lighthouse-components";
import React from "react";
import { handleConvertDate } from "../../../../utils/dateFunctions";
import MyPageTag from "../../myPageTag/myPageTag";
import "./infoLine.scss";

interface InfoLineProps {
  textKey?: string;
  value?: string | number;
  dateValue?: Date;
  onClick?: () => void;
  icon?: boolean;
  longKey?: boolean;
  tag?: string;
  tagType?: string;
}

const InfoLine = ({ textKey, value, dateValue, onClick, icon, longKey, tag, tagType }: InfoLineProps) => {
  return (
    <Grid className="infoLine">
      <GridItem
        spanLarge={longKey ? (tag ? 6 : 8) : tag ? 4 : 6}
        spanMedium={longKey ? (tag ? 6 : 8) : tag ? 4 : 6}
        spanSmall={longKey ? (tag ? 2 : 3) : tag ? 1 : 2}
      >
        <Text variant="small">{textKey}</Text>
      </GridItem>
      {tag && (
        <GridItem spanLarge={3} spanMedium={3} spanSmall={1}>
          <MyPageTag text={tag} variant={tagType} />
        </GridItem>
      )}
      <GridItem
        className="data-hj-suppress infoLine__value"
        spanLarge={longKey ? (tag ? 3 : 4) : tag ? 5 : 6}
        spanMedium={longKey ? (tag ? 3 : 4) : tag ? 5 : 6}
        spanSmall={longKey ? 1 : 2}
      >
        {dateValue ? (
          <Text variant="small">{handleConvertDate(dateValue)}</Text>
        ) : (
          <Text variant="small" onClick={onClick}>
            {value} {icon && <Icon prefix="fasr" iconName="external-link" size="s" />}
          </Text>
        )}
      </GridItem>
    </Grid>
  );
};
export default InfoLine;
